export default function() {
  /**
   * Load the images that are marked as lazy loading.
   * Sample img tag note there is no src only data-src
   * <img alt="White Lily Cake Flour" data-src="/wp-content/uploads/2017/05/flour-all-purpose.png" class="lazyLoad">
   */
  document.querySelectorAll(".lazyLoad").forEach(function(img) {
    img.src = img.dataset.src
    img.classList.remove("lazyLoad")
  })
}
